
import React, { useState } from 'react';
import { Button, MobileStepper, Typography, useTheme } from '@mui/material';
import './ImageSlider.scss';
import  gallery_01  from '../../assets/images/home/gallery/gallery_01@2x.jpg';
import  gallery_02  from '../../assets/images/home/gallery/gallery_02@2x.jpg';
import  gallery_03  from '../../assets/images/home/gallery/gallery_03@2x.jpg';
import  gallery_04  from '../../assets/images/home/gallery/gallery_04@2x.jpg';
import  gallery_05  from '../../assets/images/home/gallery/gallery_05@2x.jpg';
import { useTranslation } from 'react-i18next';


export default function ImageSlider() {
  const theme = useTheme();
  const { t } = useTranslation();

  const gallery = [
    {
      label: t('home-slider.label_01'),
      imgPath: gallery_01,
    },
    {
      label: t('home-slider.label_02'),
      imgPath: gallery_02,
    },
    {
      label: t('home-slider.label_03'),
      imgPath: gallery_03,
    },
    {
      label: t('home-slider.label_04'),
      imgPath: gallery_04,
    },
    {
      label: t('home-slider.label_05'),
      imgPath: gallery_05,
    }
  ];

  const [activeStep, setActiveStep] = useState(Math.floor(Math.random()*gallery.length));
  const maxSteps = gallery.length;

  const handleNext = () => {
    (activeStep === maxSteps - 1) ? setActiveStep(0) : setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div className='image-slider-content'>
      <img src={gallery[activeStep].imgPath} alt={gallery[activeStep].label} />
      <div className='header'>
        <Typography>{gallery[activeStep].label}</Typography>
      </div>
      <MobileStepper
        steps={maxSteps}
        position='static'
        variant='dots'
        activeStep={activeStep}
        className='dots'
        nextButton={
          <Button className='next' size='small' onClick={handleNext}>
            {theme.direction === 'rtl' ? <i className="icon-chevron-thin-left" /> : <i className='icon-chevron-thin-right' /> }
          </Button>
        }
        backButton={
          <Button className='back' size='small' onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? <i className='icon-chevron-thin-right' /> : <i className="icon-chevron-thin-left" /> }
          </Button>
        }
      />
    </div>
  );
}
